"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeIcon = exports.Iconista = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const getUrl_1 = require("iconista/lib/getUrl");
const context_1 = require("../../styles/context");
const useMountedState_1 = tslib_1.__importDefault(require("react-use/lib/useMountedState"));
const { useEffect, useState, useRef } = React;
const cache = {};
// Replace literal `fill`/`stroke` colors in SVG source with `currentColor` so
// the icon picks up the surrounding CSS `color`.
const PAINT_RE = /\b(fill|stroke)=(["'])(?!(?:none|currentColor|transparent)\2|url\()[^"']*\2/g;
const SVG_OPEN_RE = /^(\s*<svg)([^>]*)(>)/;
const normalizeColors = (svgText) => {
    let out = svgText.replace(PAINT_RE, '$1=$2currentColor$2');
    // Ensure the outer <svg> has a fill so inner paths without their own fill
    // (e.g. ibm_16) inherit the cascade.
    out = out.replace(SVG_OPEN_RE, (m, open, attrs, close) => /\bfill=/.test(attrs) ? m : `${open} fill="currentColor"${attrs}${close}`);
    return out;
};
const Svg = ({ set, icon, getUrl = getUrl_1.getUrl, ...rest }) => {
    const ref = useRef(null);
    const mounted = (0, useMountedState_1.default)();
    const [error, setError] = useState();
    useEffect(() => {
        const applyDoc = (doc) => {
            const el = ref.current;
            if (!el)
                return;
            el.innerHTML = '';
            const svg = doc.getRootNode().childNodes[0];
            const { childNodes } = svg;
            // Set SVG child nodes.
            for (let i = 0; i < childNodes.length; i++)
                el.appendChild(childNodes[i].cloneNode(true));
            // Set SVG attributes.
            for (let i = 0; i < svg.attributes.length; i++) {
                const { name, value } = svg.attributes[i];
                el.setAttribute(name, value);
            }
        };
        const key = `${set}:${icon}`;
        if (cache[key])
            applyDoc(cache[key]);
        else {
            const el = ref.current;
            if (el && typeof rest.width === 'number' && typeof rest.height === 'number') {
                el.innerHTML = `<circle cx="${rest.width / 2}" cy="${rest.height / 2}" r="${Math.min(rest.width, rest.height) / 2}" fill="rgba(127,127,127,0.2)" />`;
            }
            const url = getUrl({ set, icon });
            fetch(url, { cache: 'force-cache' })
                .then((r) => r.text())
                .then((text) => {
                if (!mounted())
                    return;
                const parser = new DOMParser();
                const doc = parser.parseFromString(normalizeColors(text), 'application/xml');
                applyDoc((cache[key] = doc));
            })
                .catch((error) => {
                if (!mounted())
                    return;
                setError(error);
            });
        }
    }, [set, icon]);
    if (error) {
        const url = getUrl({ set, icon });
        return React.createElement("img", { ...rest, src: url, alt: `${set}/${icon}`, title: error.message });
    }
    return React.createElement("svg", { ref: ref, ...rest });
};
const Iconista = ({ color, style, ...rest }) => {
    const styles = (0, context_1.useStyles)();
    const iconColor = color || styles.g(0.1, 0.9);
    return React.createElement(Svg, { ...rest, style: { color: iconColor, ...style } });
};
exports.Iconista = Iconista;
const makeIcon = (icon) => {
    // Preload
    const url = (0, getUrl_1.getUrl)(icon);
    fetch(url, { cache: 'force-cache' }).catch(() => { });
    return (props) => React.createElement(exports.Iconista, { ...icon, ...props });
};
exports.makeIcon = makeIcon;
